import Bnb from './bnb.svg';
import Bonk from './bonk.svg';
import Btc from './btc.svg';
import Doge from './doge.svg';
import Eth from './eth.svg';
import EuroIcon from './euro.svg';
import Every from './every.svg';
import Ltc from './ltc.svg';
import Matic from './matic.svg';
import Shib from './shib.svg';
import Sol from './sol.svg';
import Trx from './trx.svg';
import Usdc from './usdc.svg';
import Usdt from './usdt.svg';
import Wif from './wif.svg';
import Xrp from './xrp.svg';
import Ton from './ton.svg';

export const currencyIcons: CurrencyIconsInterface = {
	bnb: Bnb,
	bonk: Bonk,
	btc: Btc,
	doge: Doge,
	eth: Eth,
	eur: EuroIcon,
	every: Every,
	ltc: Ltc,
	ltct: Ltc,
	matic: Matic,
	shib: Shib,
	sol: Sol,
	trx: Trx,
	usdc: Usdc,
	usdt: Usdt,
	wif: Wif,
	xrp: Xrp,
	ton: Ton,
	// bnb: () => import('./bnb.svg'),
	// bonk: () => import('./bonk.svg'),
	// btc: () => import('./btc.svg'),
	// doge: () => import('./doge.svg'),
	// eth: () => import('./eth.svg'),
	// eur: () => import('./euro.svg'),
	// every: () => import('./every.svg'),
	// ltc: () => import('./ltc.svg'),
	// ltct: () => import('./ltc.svg'),
	// matic: () => import('./matic.svg'),
	// shib: () => import('./shib.svg'),
	// sol: () => import('./sol.svg'),
	// trx: () => import('./trx.svg'),
	// usdc: () => import('./usdc.svg'),
	// usdt: () => import('./usdt.svg'),
	// wif: () => import('./wif.svg'),
	// xrp: () => import('./xrp.svg'),
};

export interface CurrencyIconsInterface {
	bnb: React.FC<React.SVGProps<SVGSVGElement>>;
	bonk: React.FC<React.SVGProps<SVGSVGElement>>;
	btc: React.FC<React.SVGProps<SVGSVGElement>>;
	doge: React.FC<React.SVGProps<SVGSVGElement>>;
	eth: React.FC<React.SVGProps<SVGSVGElement>>;
	eur: React.FC<React.SVGProps<SVGSVGElement>>;
	every: React.FC<React.SVGProps<SVGSVGElement>>;
	ltc: React.FC<React.SVGProps<SVGSVGElement>>;
	ltct: React.FC<React.SVGProps<SVGSVGElement>>;
	matic: React.FC<React.SVGProps<SVGSVGElement>>;
	shib: React.FC<React.SVGProps<SVGSVGElement>>;
	sol: React.FC<React.SVGProps<SVGSVGElement>>;
	trx: React.FC<React.SVGProps<SVGSVGElement>>;
	usdc: React.FC<React.SVGProps<SVGSVGElement>>;
	usdt: React.FC<React.SVGProps<SVGSVGElement>>;
	wif: React.FC<React.SVGProps<SVGSVGElement>>;
	xrp: React.FC<React.SVGProps<SVGSVGElement>>;
	ton: React.FC<React.SVGProps<SVGSVGElement>>;
	// bnb: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// bonk: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// btc: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// doge: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// eth: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// eur: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// every: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// ltc: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// ltct: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// matic: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// shib: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// sol: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// trx: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// usdc: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// usdt: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// wif: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
	// xrp: () => Promise<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>;
}
